import React, { memo } from "react";
import { HStack, Text, Highlight, Circle } from "@chakra-ui/react";
import colors from "app/colors";
import {
  ArchivedPeopleOutlineIcon,
  PeopleOutlineIcon,
  ExternalIcon,
} from "modules/icons";
import { getDistributionGroupMention } from "modules/utils/Functions";

interface IProps {
  distributionGroup?: {
    name: string;
    emailUserIdList: string[];
    active: boolean;
  };
  search: string;
}

const DistributionGroupOptionLabel = ({
  distributionGroup,
  search,
}: IProps) => {
  if (!distributionGroup) return null;

  if (distributionGroup.active) {
    return (
      <HStack>
        <Circle backgroundColor={colors.blueLighter} size={8}>
          <PeopleOutlineIcon boxSize={6} fill={colors.blue} />
        </Circle>
        <Text noOfLines={1} fontSize={14} color={colors.blue} fontWeight={700}>
          <Highlight
            query={search}
            styles={{
              fontWeight: 700,
              color: colors.blue,
              margin: "0 !important",
            }}
          >
            {getDistributionGroupMention(distributionGroup)}
          </Highlight>
        </Text>
        {distributionGroup.emailUserIdList.length > 0 && (
          <ExternalIcon fill={colors.transparent} />
        )}
      </HStack>
    );
  }

  return (
    <HStack color={colors.grayMain}>
      <ArchivedPeopleOutlineIcon boxSize={5} />
      <Text noOfLines={1} fontSize={12} fontWeight={500} fontStyle="italic">
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.gray80,
            margin: "0 !important",
          }}
        >
          {getDistributionGroupMention(distributionGroup)}
        </Highlight>
      </Text>
      {distributionGroup.emailUserIdList.length > 0 && (
        <ExternalIcon fill={colors.transparent} />
      )}
    </HStack>
  );
};

export default memo(DistributionGroupOptionLabel);
